<template>
  <form v-if="production" class="prod-stack" @submit.prevent="onSave">
    <div class="move-card prod-panel space-y-5">
      <ProductionSectionHead title="Editing" subtitle="Who’s cutting, where the cut lives, and how far along it is." />
      <div class="move-field !mb-0">
        <label for="editor-user">Editor (workspace member)</label>
        <MoveSelect
          id="editor-user"
          v-model="form.editor_user_id"
          block
          placeholder="None / external"
          :options="editorOptions"
        />
      </div>
      <div class="move-field !mb-0">
        <label for="editor-name">Editor name (if external)</label>
        <input id="editor-name" v-model="form.editor_name" class="move-input" placeholder="Freelance editor" />
      </div>
      <div class="move-field !mb-0">
        <label for="edit-status">Edit status</label>
        <MoveSelect id="edit-status" v-model="form.edit_status" block :options="editStatusOptions" />
      </div>
      <div class="move-field !mb-0">
        <label for="edit-asset">Cut / asset URL</label>
        <div class="flex gap-2">
          <input id="edit-asset" v-model="form.edit_asset_url" class="move-input" placeholder="https://" />
          <a
            v-if="form.edit_asset_url"
            :href="form.edit_asset_url"
            target="_blank"
            rel="noopener"
            class="move-btn-ghost shrink-0"
            aria-label="Open cut"
          >
            <span class="material-icons">open_in_new</span>
          </a>
        </div>
      </div>
      <div class="move-field !mb-0">
        <label for="edit-notes">Notes</label>
        <textarea id="edit-notes" v-model="form.edit_notes" rows="4" class="move-textarea" />
      </div>
      <p v-if="message" class="prod-success">{{ message }}</p>
      <button type="submit" class="move-btn-primary">Save editing</button>
    </div>
  </form>
</template>

<script setup>
import { computed, inject, onMounted, reactive, ref, watch } from 'vue'
import ProductionSectionHead from '../../components/production/ProductionSectionHead.vue'
import { productionApi } from '../../services/productionApi'
import { editStatusOptions } from '../../config/productionNavigation'

const workspace = inject('productionWorkspace')
const production = workspace.production
const team = ref([])
const message = ref('')
const form = reactive({
  editor_user_id: '',
  editor_name: '',
  edit_status: 'not_started',
  edit_asset_url: '',
  edit_notes: ''
})

const editorOptions = computed(() => [
  { value: '', label: 'None / external' },
  ...team.value.map((user) => ({
    value: String(user.user_id),
    label: `${user.name} ${user.surname}`
  }))
])

watch(production, (value) => {
  if (!value) return
  form.editor_user_id = value.editor_user_id ? String(value.editor_user_id) : ''
  form.editor_name = value.editor_name || ''
  form.edit_status = value.edit_status || 'not_started'
  form.edit_asset_url = value.edit_asset_url || ''
  form.edit_notes = value.edit_notes || ''
}, { immediate: true })

async function onSave () {
  await workspace.save({
    editor_user_id: form.editor_user_id ? Number(form.editor_user_id) : null,
    editor_name: form.editor_name || null,
    edit_status: form.edit_status,
    edit_asset_url: form.edit_asset_url || null,
    edit_notes: form.edit_notes || null
  })
  message.value = 'Editing saved.'
}

onMounted(async () => {
  const body = await productionApi.assignableTeam()
  team.value = body.data || []
})
</script>
